import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'matchingTerm',
    standalone: false
})
export class MatchingTermPipe implements PipeTransform {
    transform(value: string, items: string[]): string {
        return items?.find((item: string) => value?.toLowerCase().includes(item)) || '';
    }
}
